import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeApplierDirective } from './core/theme/theme-applier.directive';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [ThemeApplierDirective],
})
export class AppComponent {
  title = 'tull-portal';
}
